<div class="unauthorised">
  <i class="material-symbols-outlined">warning</i>
  <p>{{ message }}</p>
</div>
